import { throttle } from 'lodash-es'
import { navigatePage } from '@/common/utils.ts'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'
import {getActiveApps} from "@micro-zoe/micro-app";

export default function useMenuRoute() {
  const { selectedApp, setMenuRouteCache } = useGlobalStore(
    useShallow((state: any) => ({
      selectedApp: state.selectedApp,
      setMenuRouteCache: state.setMenuRouteCache,
    }))
  )

  const navigate = useNavigate()
  const [menuKeys, setMenuKeys]: any[] = useState([])
  const menuClick = throttle(item => {
    const { apppath, key, path = '' } = item
    // console.log('handleMenuClick：', item, key, keyPath)
    // console.log(defaultSelectedKeys);

    if (key === menuKeys[0]) {
      return
    }

    // setBreadCrumbList([
    //   {
    //     title: currentMenu[0]?.name
    //   },
    //   {
    //     title: <span style={{cursor: 'pointer'}} onClick={() => handleMenuClick({ item, key, keyPath })} >{name}</span>
    //   }
    // ]);

    if (apppath == '/main') {
      // navigate(apppath + path)
      // finChoseItem(apppath + path)
      // onTabChange(apppath + path)
    } else {
      // const pathName = path.slice(1);
      // const appPathName = apppath.slice(1);
      if (path?.includes?.('http') || path?.includes?.('https')) {
        window.open(path)
        return
      }

      if (path?.includes?.('location::')) {
        //console.log(window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + path.replace('location::',''));
        window.open(
          window.location.protocol +
            '//' +
            window.location.hostname +
            path.replace('location::', '')
        )
        return
      }

      let wholePath = apppath === '/' ? path : apppath + path;
      if (wholePath.startsWith('$')) {
        wholePath = wholePath.replace('$', '')
      }
      setMenuRouteCache(selectedApp.nid, wholePath)
      if (apppath === '/' && !path.startsWith('$')) {
        navigate(path)
      } else {
        navigatePage(apppath, path, navigate)
      }
      setMenuKeys([key])
    }
  }, 800)
  return {
    menuClick,
    setMenuKeys,
  }
}
